module.exports = __webpack_public_path__ + "media/images/lp/1/history2-pc-72b32450e7025c727d73568558913698.png";